import moment from "moment";

export const INITIAL_STATE_SALE_BILL = {
  id: "",
  tipo: "entrada",
  idCliente: "",
  idFuncionario: "",
  idFormaPagamento: "",
  idContaRecebimento: "",
  idVenda: "",
  idUnion: null,
  valorTotal: 0.0,
  valorPago: 0.0,
  valorRestante: 0.0,
  parcelas: null,
  data: moment().format("YYYY-MM-DD"),
  dataPagamento: null,
  dataCompetencia: null,
  idCategoria: null,
  descricao: "",
  observacoes: "",
  codigoReferencia: "",
}